import { render, staticRenderFns } from "./marquee.vue?vue&type=template&id=46d90844&lang=pug&"
import script from "./marquee.vue?vue&type=script&lang=js&"
export * from "./marquee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports